import clsx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IStickyFooterProps {
  theme?: 'dark';
}

export const StickyFooter: React.FC<IStickyFooterProps & React.PropsWithChildren> = ({ theme, children }) => {
  return <div className={clsx(styles['container'], { [styles['dark']]: theme === 'dark' })}>{children}</div>;
};

StickyFooter.displayName = 'StickyFooter';
